import { Add, Edit, Trash } from "iconsax-react";
import DBTable from "../../../../component/global/DBTable/DBTable";
import { t } from "i18next";

export default function LanguageTable(props) {
    const { data, onDelete, onEdit } = props;

    const headers = [
        {
            id: "title",
            title: t("item.type.name"),
            gridTemplateColumns: "2fr",
        },
        {
            id: "language",
            title: t("item.type.language.select"),
            gridTemplateColumns: "1fr",
        },
        {
            id: "options",
            title: t("options"),
            gridTemplateColumns: "70px",
        },
    ];

    const rows = data?.map((item, index) => {
        return {
            title: item.name,
            language: item.language,
            options: (
                <div className="option-buttons">
                    <Edit
                        size="18"
                        color="#2e71fc"
                        onClick={() => onEdit(index)}
                    />
                    <Trash
                        size="18"
                        color="red"
                        onClick={() => onDelete(index)}
                    />
                </div>
            ),
        };
    });

    return <DBTable minWidth={500} headers={headers} rows={rows} />;
}
